// LabelStore.ts

type BreadcrumbItem = { [label: string]: string };
type BreadcrumbsListener = (items: BreadcrumbItem[]) => void;

class BreadCrumbsStore {
  private breadCrumbsArray: BreadcrumbItem[] = [];
  private listeners: BreadcrumbsListener[] = [];

  getLabel() {
    return this.breadCrumbsArray;
  }

  updateBreadCrumbs(newItems: BreadcrumbItem[]) {
    this.breadCrumbsArray = newItems;
    this.listeners.forEach(listener => listener(this.breadCrumbsArray));
  }

  subscribe(listener: BreadcrumbsListener) {
    this.listeners.push(listener);
    listener(this.breadCrumbsArray); // call immediately with current state
    return () => {
      this.listeners = this.listeners.filter(l => l !== listener);
    };
  }
}

export const breadCrumbsStore = new BreadCrumbsStore();
